import { useSelector } from 'react-redux'
import { hasWebpSupport } from '@/logic/app/reducer'
import type { TUseWebpExtension } from './interfaces'

export const useWebpExtension: TUseWebpExtension = (defaultExtension = 'png') => (useSelector(hasWebpSupport()) ? 'webp' : defaultExtension)
